import { ShopLocationItem } from '@/lib/types/location/shop'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface LocationsState {
  items: ShopLocationItem[]
  loading: boolean
  error: string | null
}

const initialState: LocationsState = {
  items: [],
  loading: false,
  error: null,
}

const locationsSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    setLocations(state, action: PayloadAction<ShopLocationItem[]>) {
      state.items = action.payload
    },
  },
})

export const { setLocations } = locationsSlice.actions
export default locationsSlice.reducer
